/** Vite `--mode` 값 (development | qa | production 등) */
export const appMode = import.meta.env.MODE;

export const isDevelopment = appMode === "development";
export const isLocal = appMode === "test";
export const isQa = appMode === "qa";
export const isProduction = appMode === "production";

/** QA·개발 빌드에서만 디버그 유지보수 UI/API 허용 (production 빌드 제외) */
export const isDebugMode = appMode === "development" || appMode === "qa" || appMode === "test";

/**
 * 보호자 계정 생성(app-account-setting) 플로우를 API 호출 없이 Mock 데이터로 확인하는 모드.
 * `npm run dev:mock` 으로 켜며, development 모드가 아니면 환경변수가 있어도 항상 false 다.
 */
export const isMockAppAccountSetting =
  isDevelopment && import.meta.env.VITE_MOCK_APP_ACCOUNT_SETTING === "true";
